import { useCallback, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useClearTasks } from '../..';
import {
  actions as tasksActions,
  selectors as tasksSelectors,
} from '../../../../store/tasks';

const useDeleteTask = () => {
  const deleteTaskIsFetching = useSelector(
    tasksSelectors.selectDeleteTaskIsFetching,
  );

  const deleteTaskSuccess = useSelector(tasksSelectors.selectDeleteTaskSuccess);

  const deleteTaskError = useSelector(tasksSelectors.selectDeleteTaskError);

  const dispatch = useDispatch();

  const deleteTask = useCallback(
    (id) => {
      dispatch(tasksActions.deleteTaskRequest(id));
    },
    [dispatch],
  );

  const clearTasks = useClearTasks();

  useEffect(() => {
    clearTasks();
  }, [clearTasks]);

  return {
    deleteTask,
    deleteTaskIsFetching,
    deleteTaskSuccess,
    deleteTaskError,
    clearTasks,
  };
};

export default useDeleteTask;
